import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, LinearProgress } from '@mui/material';
import React, { Component } from "react";
import { connect } from 'react-redux';
import AccountsApi from '../../api/accounts';
import { showMessage } from '../../actions/uiActions';
import archiveOption from '../../components/Users/archiveOptions.json'
import { forgivenessType } from './forgvenessType';
class Archive extends Component {
    state = {
        processing: false,
        reason_key: '',
        reason_description: '',
        forgiven_amount: 0,
        forgiven_date: null,
        forgiveness_type: "",
        refund_amount:0
    }

    determineForgivenessValues = () => {
        const { reason_key, forgiven_amount, refund_amount, forgiven_date, forgiveness_type } = this.state;
        if (reason_key === "forgiven") {
            return {
                forgiven_amount,
                forgiven_date,
                refund_amount,
                forgiveness_type
            }
        } else {
            return {
                forgiven_amount: 0,
                forgiven_date: null
            }
        }
    }

    handleSubmit = async () => {
        const { userId, showMessage, onClose, onSuccess } = this.props;
        const { reason_key, reason_description, forgiven_amount, forgiven_date } = this.state;
        try {
            if (reason_key && reason_description) {
                if (reason_key === "forgiven" && (!forgiven_amount || !forgiven_date)) {
                    showMessage("Kindly provide Forgiveness amount and the Date.");
                } else {
                    this.setState({ processing: true })
                    await AccountsApi.archiveUser(userId, { reason_key, reason_description, ...this.determineForgivenessValues() })
                    showMessage('The Account has been archived');
                    this.setState({ processing: false })
                    onSuccess();
                    onClose();
                }
                
            } else {
                showMessage("All fields are required.");
            }

        } catch (error) {
            showMessage(error);
            this.setState({ processing: false })
        }
    }

    handleChanges = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    render() {
        const { onClose } = this.props;
        const {forgiveness_type, reason_key, refund_amount, processing, reason_description, forgiven_amount, forgiven_date } = this.state;

        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onClose}
            >
                <DialogTitle id="alert-dialog-title">Archive this user account</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <span className='danger mb-2'>NOTE: Performing this action will disallow the user from
                            login into their account and the user will no longer receive any email from PeopleJoy</span>
                    </DialogContentText>
                    <br />
                    <div className="form-group nice">
                        <label>Why Archiving:</label>
                        <select
                            name="reason_key"
                            onChange={this.handleChanges}
                            value={reason_key}
                            disabled={processing}
                            className="form-control"
                        >
                            <option value="">Select...</option>
                            {archiveOption.map(({ value, label }) => (
                                <option value={value} key={value}>{label}</option>
                            ))}
                        </select>
                    </div>
                    {reason_key === "forgiven" && (
                        <>
                            <div className="form-group nice">
                                <label>Forgiveness Type:</label>
                                <select
                                    name="forgiveness_type"
                                    onChange={this.handleChanges}
                                    value={forgiveness_type}
                                    disabled={processing}
                                    className="form-control"
                                >
                                    <option value="">Select...</option>
                                    {forgivenessType.map(({ value, label }) => (
                                        <option value={value} key={value}>{label}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group nice">
                                <label>Forgiveness Amount:</label>
                                <input
                                    disabled={processing}
                                    type="number"
                                    className="form-control"
                                    placeholder="Forgiveness Amount"
                                    name="forgiven_amount"
                                    value={forgiven_amount}
                                    onChange={this.handleChanges}
                                />
                            </div>
                            <div className="form-group nice">
                                <label>Refund Amount:</label>
                                <input
                                    disabled={processing}
                                    type="number"
                                    className="form-control"
                                    placeholder="Refund Amount"
                                    name="refund_amount"
                                    value={refund_amount}
                                    onChange={this.handleChanges}
                                />
                            </div>
                            <div className="form-group nice">
                                <label>Forgiveness Date:</label>
                                <input
                                    disabled={processing}
                                    type="date"
                                    className="form-control"
                                    placeholder="Forgiveness Date"
                                    name="forgiven_date"
                                    value={forgiven_date}
                                    onChange={this.handleChanges}
                                    min="2020-01-01"
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                        </>
                        
                    )}
                    <div className="form-group nice">
                        <label>Give more details:</label>
                        <textarea
                            type="text"
                            className="form-control"
                            value={reason_description}
                            onChange={this.handleChanges}
                            name="reason_description"
                            placeholder="Give more details"
                        ></textarea>
                    </div>
                    {processing && <LinearProgress />}
                </DialogContent>
                {!processing && (
                    <DialogActions>
                        <Button
                            variant="outlined"
                            onClick={this.handleSubmit}
                            color="primary"
                            autoFocus
                        >
                            Archive
                        </Button>
                        <Button onClick={onClose} color="primary">
                            Cancel
                        </Button>
                    </DialogActions>
                )}
            </Dialog>
        )
    }
}
export default connect(null, { showMessage })(Archive);